<template>
  <div class="relative group" v-if="profile">
    <!-- Кнопка профиля -->
    <button class="flex items-center space-x-1 focus:outline-none">
      <!-- Иконка пользователя -->
      <div class="w-6 h-6 rounded-full bg-blue-500 flex items-center justify-center text-white">
        <svg xmlns="http://www.w3.org/2000/svg" class="h-5 w-5" fill="none" viewBox="0 0 24 24" stroke="currentColor">
          <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M16 7a4 4 0 11-8 0 4 4 0 018 0zM12 14a7 7 0 00-7 7h14a7 7 0 00-7-7z" />
        </svg>
      </div>

      <!-- Имя пользователя -->
      <span class="font-medium text-gray-100">
        <router-link :to="{ name: 'profile' }">
          <span>{{profile.login}}</span>
        </router-link>
      </span>

      <!-- Стрелка -->
      <svg xmlns="http://www.w3.org/2000/svg" class="h-4 w-4 text-gray-500 group-hover:rotate-180 transition-transform" fill="none" viewBox="0 0 24 24" stroke="currentColor">
        <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M19 9l-7 7-7-7" />
      </svg>
    </button>

    <!-- Выпадающее меню -->
    <div class="absolute right-0 mt-0 mr-5 w-48 bg-white rounded-md shadow-lg py-1 z-10 hidden group-hover:block">
      <router-link :to="{ name: 'profile' }" class="block px-4 py-2 text-sm text-gray-700 hover:bg-gray-100">
        Профиль
      </router-link>
<!--      <a href="#" class="block px-4 py-2 text-sm text-gray-700 hover:bg-gray-100">Настройки</a>-->
      <div class="border-t border-gray-200"></div>
      <a href="#" @click.prevent="logout" class="block px-4 py-2 text-sm text-red-600 hover:bg-gray-100">Выйти</a>
    </div>
  </div>
  <div v-else>
    Профиль: <a href="#" @click.prevent="logout">Выйти</a>
  </div>
  <ModalWindow :show="confirmExitModal" @close="confirmExitNo" @done="confirmExitDone" title="Выход">
    {{ "Продолжить?" }}
  </ModalWindow>
</template>

<script>
import store from '@/store.js'
import ModalWindow from "@/components/modal/ModalWindow.vue";

export default {
  name: 'TopUserProfile',
  components: {ModalWindow},
  data() {
    return {
      store,
      confirmExitModal: false,
      profile: null
    }
  },
  methods: {
    confirmExitNo: function () {
      this.confirmExitModal = false;
    },
    confirmExitDone: function () {
      this.store.commit('unauthorize')
      this.confirmExitModal = false;
    },
    logout: function () {
      this.confirmExitModal = true;
    },
    loadProfile: function () {
      console.log("loadProfile")
      let c = this;
      this.axios.get('/api/profile', this.formData).then(function(response) {
        console.log(response.data);
        c.profile = response.data.data;
        c.store.commit('setRoles', c.profile.roles);
      }).catch(function(err) {
        console.log(err.status);
      });
    }
  },
  mounted() {
    this.loadProfile()
  }
}
</script>

<style scoped>

</style>